const Services = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1 className="text-center mb-4">My Services</h1>
      <ul className="list-unstyled">
        <li className="mb-3">
          <strong>Software Development:</strong> Build custom software applications tailored to business needs, ensuring scalability and efficiency.
        </li>
        <li className="mb-3">
          <strong>AI API Integration:</strong> Integrate AI-powered APIs (e.g., OpenAI, Google AI) into applications to enhance functionality and user experience.
        </li>
        <li className="mb-3">
          <strong>Prompt Engineering:</strong> Craft precise and effective prompts to optimize AI model outputs for specific use cases.
        </li>
        <li className="mb-3">
          <strong>Data Engineering:</strong> Design and implement scalable data pipelines to process and analyze large datasets efficiently.
        </li>
        <li className="mb-3">
          <strong>Cloud Architecture:</strong> Optimize and manage cloud-based systems using AWS, Azure, and Linode for high availability and performance.
        </li>
        <li className="mb-3">
          <strong>Data Analytics:</strong> Provide actionable insights through data visualization and analytics tools like Excel, Power BI, and Pandas.
        </li>
      </ul>
    </div>
  );
};

export default Services;
